import { useTranslation } from 'helpers/hooks/useTranslation'
import React from 'react'
import styled from 'styled-components'
import { softGrayColor } from 'uiComponents/constants/colors'
import {
  fsM,
  fsXS,
  fwBold,
  fwMediumBold,
} from 'uiComponents/constants/typography'

const MARGIN_TOP = 30
const MARGIN_BOTTOM = 10

const Headline = styled.h3`
  margin: ${MARGIN_TOP}px 0 ${MARGIN_BOTTOM}px;
  font-size: ${fsM}px;
  line-height: 1;
  ${fwBold};
  align-self: flex-start;
`

const Small = styled.span`
  padding-left: 15px;
  font-size: ${fsXS}px;
  color: ${softGrayColor};
  ${fwMediumBold};
`

interface Props {
  idolName: string
  outfitCount: number
}

const IdolStoryOutfitHeader: React.FC<Props> = props => {
  const { t } = useTranslation()

  return (
    <Headline data-testid="EditorialIdolStoryOutfitHeader">
      {t('Alle Outfits von')} {props.idolName}
      <Small>
        {props.outfitCount} {t('Outfits')}
      </Small>
    </Headline>
  )
}

export function calcHeight() {
  return MARGIN_TOP + MARGIN_BOTTOM + fsM
}

export default IdolStoryOutfitHeader
